import React from 'react'
import { Box, FormControl, TextField, MenuItem } from '@mui/material'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
import { BlockSettingsProps } from './types'
export const BlockContainerSettings: React.FC<BlockSettingsProps> = ({
    kedo,
    state,
    handleChangeSettings,
}) => {
    return (
        <Box sx={{ mt: 2 }}>
            <FormControl fullWidth margin="normal">
                <FormInputLabel>{kedo.t('Layout')}</FormInputLabel>
                <TextField
                    select
                    size="small"
                    name="layout"
                    value={state.item.settings.layout || 'horizontal'}
                    onChange={(e) =>
                        handleChangeSettings('layout', e.target.value)
                    }
                >
                    <MenuItem value="horizontal">
                        {kedo.t('Horizontal')}
                    </MenuItem>
                    <MenuItem value="vertical">{kedo.t('Vertical')}</MenuItem>
                </TextField>
            </FormControl>
        </Box>
    )
}
